import { CELL_CLASS } from './grid-common';
import { getMetadataValue } from '../../../api/metadata';
import { metadataGridFilter } from './metadata-fllters';
import { getStoredFilter } from '../filters/filter-common';

const getMetadataValueFromParams = (params) => {
  const candidate = params.data;
  const metadata = candidate.metadata;
  return getMetadataValue(metadata, params.colDef.colId, params.colDef.field, '');
};

export const getMetadataCellValue = (params) => {
  return getMetadataValueFromParams(params);
};

export const getMetadataNumericCellValue = (params) => {
  const metadataValue = getMetadataValueFromParams(params);
  if (metadataValue) {
    if (Number.isFinite(metadataValue)) {
      return metadataValue;
    }

    if (metadataValue?.length > 0) {
      const value = metadataValue.replace(/[^0-9.]/g, '');
      if (value?.length > 0) {
        return +value;
      }
      return Number.MIN_SAFE_INTEGER + 1;
    }
  }

  return Number.MIN_SAFE_INTEGER;
};

export const buildMetadataColumn = (attributes, metadataSpec) => {
  const attributeId = `${metadataSpec.attribute}`;
  const metadataColumn = {
    headerName: attributes[attributeId].displayName,
    colId: attributes[attributeId].name,
    field: 'value',
    cellClass: CELL_CLASS,
    wrapHeaderText: true,
    minWidth: 150,
    maxWidth: 300,
  };
  if (metadataSpec.format === 'text') {
    metadataColumn.valueGetter = getMetadataCellValue;
    if (metadataSpec.filtered) {
      const filter = getStoredFilter(attributes[attributeId].name);
      if (filter) {
        metadataColumn.filter = metadataGridFilter;
        metadataColumn.filterParams = {
          isMetadata: true,
          attribute: attributes[attributeId],
        };
      } else {
        metadataColumn.sortable = false;
      }
    } else {
      metadataColumn.filter = 'agTextColumnFilter';
      metadataColumn.filterParams = {
        filterOptions: ['contains', 'equals'],
        suppressAndOrCondition: true,
      };
    }
  } else {
    metadataColumn.valueGetter = getMetadataNumericCellValue;
    metadataColumn.valueFormatter = getMetadataCellValue;
  }

  return metadataColumn;
};
